import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()(() => ({
    container: {
        height: '100%',
        width: '100%',
        position: 'relative'
    }
}))

export default useStyles